import React, { Component } from 'react'
import { Row } from 'react-bootstrap';
import { withRouter } from "react-router-dom";
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import moment from 'moment'
import config from 'react-global-configuration';
import { DoubleBounce } from 'better-react-spinkit'

import { BorderLine, SpinnerWrapper } from '../GeneralStyle'
import { ProfileBox, ProfileLabels, ProfileH5, LabelWrapper, CircleImage } from './ProfileStyle'


@inject('userStore', 'bookingStore', 'configStore')

@observer
class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  // Check https://github.com/mobxjs/mobx-react/blob/master/README.md#faq
  // to see why I did this (componentWillMount())
  // To replicate the error that occurs otherwise put
  // this.props.bookingStore.getActiveBookings()
  componentWillMount() {
    this.props.bookingStore.getActiveBookings()
  }


  render() {
    const { isLoggedIn, me, company, isResidenceRole, sendResetPasswordMail, remainingCoins } = this.props.userStore
    // TODO: Bug -For new users isUserFreeBookings seems to be always false.
    const { userFreeBookings, maxBookingCount, bookingCount, bookingRemainingStockCount, maxRemainingStockBookingCount } = this.props.bookingStore
    const { isConfig, whatsappGroupLink } = this.props.configStore

    return (
      <ProfileBox>
        {isLoggedIn && isConfig
          ? <div>
            <Row>
              <div>
                <CircleImage size={100} image={`${config.get('CLOUDINARY_URL')}${me.profileImage}.jpg`} />
              </div>
            </Row>
            <Row>
              <LabelWrapper>
                <div>
                  <div onClick={() => this.props.history.push("/partner/" + company.shortname)}>
                    <ProfileH5>{me.firstname + ' ' + me.lastname} </ProfileH5>
                    <ProfileLabels>{me.position} bei </ProfileLabels>
                    <ProfileLabels color={"#DAB777"}><strong>{company.name}</strong></ProfileLabels>
                    <BorderLine />
                  </div>

                  {<ProfileLabels color={"#DAB777"}>{!userFreeBookings ? "0 Buchungen" : userFreeBookings === 1 ? "eine Buchung" : userFreeBookings + " Buchungen"}</ProfileLabels>}
                  <ProfileLabels>freies Kontingent</ProfileLabels>

                  <BorderLine />

                  {<ProfileLabels color={"#DAB777"}>{ remainingCoins } von { company.coins }</ProfileLabels>}
                  <ProfileLabels>Credits verbleibend</ProfileLabels>

                  <BorderLine />

                  <a style={{cursor: 'pointer'}} onClick={() => this.props.history.push("/internal/contracts-invoices/")}>
                    <ProfileLabels>Rechnungen & Verträge</ProfileLabels>
                  </a>
                  <BorderLine />
                  
                  <a style={{cursor: 'pointer'}} onClick={() => this.props.history.push("/internal/tournament/")}>
                    <ProfileLabels>Turnier Anmeldung</ProfileLabels>
                  </a>
                  <BorderLine />

                  {/* UNCOMMENT TO ENABLE PASSWORD CHANGE
                    <a style={{ cursor: 'pointer' }} onClick={() => sendResetPasswordMail()}>
                      <ProfileLabels>Passwort ändern</ProfileLabels>
                    </a>
                  <BorderLine />
                  */}

                  <ProfileLabels>Mitglied seit</ProfileLabels>
                  <ProfileLabels color={"#DAB777"}>{moment(me.createdAt).locale("de").format('Do MMMM YYYY')}</ProfileLabels>
                  {/* <BorderLine />
                  <a href={whatsappGroupLink} target={"_blank"}><ProfileLabels>zur Whatsapp Gruppe</ProfileLabels></a> */}
                </div>
              </LabelWrapper>
            </Row>
          </div>
          : <SpinnerWrapper>
            <DoubleBounce color={"#DAB777"} size={35} />
          </SpinnerWrapper>}
      </ProfileBox>
    )
  }
}

Profile.propTypes = {
  userStore: MobxPropTypes.observableObject,
  bookingStore: MobxPropTypes.observableObject,
  configStore: MobxPropTypes.observableObject,
};

export default withRouter(Profile);



// WEBPACK FOOTER //
// /src/components/internal/Profile.js